import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";

// material-ui components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

import styles from "../../assets/jss/styles/components/buttonStyle";

//@ts-ignore
const useStyles = makeStyles(styles);

interface RegularButtonProps {
  color?: "primary" |
    "info" |
    "success" |
    "warning" |
    "danger" |
    "rose" |
    "white" |
    "transparent"
  size?: "sm" | "lg",
  simple?: boolean,
  round?: boolean,
  disabled?: boolean,
  block?: boolean,
  link?: boolean,
  justIcon?: boolean,
  className?: any,
  // use this to pass the classes props from Material-UI
  muiClasses?: object,
  children?: any,
  href?: string,
  onClick?: any
};


const RegularButton = (props:RegularButtonProps) => {
  const classes = useStyles();
  const {
    color,
    round,
    children,
    disabled,
    simple,
    size,
    block,
    link,
    justIcon,
    className,
    muiClasses,
    ...rest
  } = props;
  const btnClasses = classNames({
    [classes.button]: true,
    [classes[size]]: size,
    [classes[color]]: color,
    [classes.round]: round,
    [classes.disabled]: disabled,
    [classes.simple]: simple,
    [classes.block]: block,
    [classes.link]: link,
    [classes.justIcon]: justIcon,
    [className]: className
  });
  return (
    <Button {...rest} onClick={props.onClick} classes={muiClasses} className={btnClasses}>
      {children}
    </Button>
  );
}

export default RegularButton;
